import Home from "../views/Home.vue";
import Login from "../views/account/login.vue";
import Logout from "../views/account/logout.vue";

import OidcCallback from "../components/Common/OidcCallback";

export const shellRoutes = [
  {
    path: "/oidc-callback/",
    name: "oidc-callback",
    component: OidcCallback,
    meta: {
      anonymous: true
    }
  },
  {
    path: "/login/",
    name: "login",
    meta: {
      anonymous: true,
      layout: "AccountLayout"
    },
    component: Login
  },
  {
    path: "/logout",
    name: "logout",
    component: Logout
  },
  {
    path: "/",
    name: "home",
    component: Home
  },
  {
    path: "/about",
    name: "about",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue")
  }
];

// const router = new VueRouter({
//   mode: "history",
//   routes
// });

export const routerBeforeEachFn = function(store) {
  return (to, from, next) => {
    let authRequired = false;
    const anonymousRequired = to.matched.some(route => route.meta.anonymous);
    if (!anonymousRequired) {
      authRequired = true;
    }

    // const groups = to.meta.groups ? to.meta.groups : [];
    if (authRequired) {
      console.log(store.state.auth.loggedIn); //eslint-disable-line
      if (store.state.auth.loggedIn) {
        // START next() when groups not applied
        next();
        // END next() when groups not applied

        // if (store.getters.userHasGroups(groups)) {
        //   next();
        // } else {
        //   if (store.getters.token) {
        //     next("/no-permission");
        //   } else {
        //     next("/login");
        //   }
        // }
      } else {
        next("/login");
      }
    } else if (anonymousRequired) {
      if (store.state.auth.loggedIn) {
        next("/");
      } else {
        next();
      }
    } else {
      next();
    }
  };
};
